import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookMonth } from "@modules/bookMonths/types";
import { BookMonthFormValues } from "@modules/bookMonths/validations";

import { createBookMonthService } from "./service";
import { UseCreateBookMonthMutationOptions } from "./types";

export function useCreateBookMonthMutation(options?: UseCreateBookMonthMutationOptions) {
  const { open } = useNotification();

  return useMutation<BookMonth, ApiError, BookMonthFormValues>({
    mutationFn: createBookMonthService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response?.data?.error ?? "Erro ao criar período",
      });
    },
    ...options,
  });
}
